module.exports = __webpack_public_path__ + "static/media/banjo.a43a8272.svg";